<template>

  <div class="wrap">

    <div class="page-header">
        <Nav :activeId="activeId" />
    </div>

    <div class="section-one">
      <img src="../../img/service/banner.jpg" />

      <div class="nav-bar">
        <div class="nav-bar_label">Housekeeper service</div>
        <div class="nav-bar_bread">
          <a href="/home">首页</a><span>班管家服务</span>班管家365服务
        </div>
        <!-- <img src="../../img/service/nav-top.png" class="product service" /> -->
      </div>

      <img src="../../img/service/title.png" class="v-c-title service-t" />
    </div>

    <div class="section-one section-service">
      <div class="bg1-info">
        <img src="../../img/service/bg-info2.png" class="" />
      </div>

      <div class="btn">
        <a href="https://oms.idcgroup.com.cn:8082/BGJGZH/index.html">
          <img src="../../img/service/btn-enter2.png" />
        </a>
      </div>
    </div>

    <Footer />

  </div>

</template>

<script>
// import $ from 'jquery'
import Nav from '../components/Nav.vue'
import Footer from '../components/Footer.vue'
export default {
  data() {
    return {
      activeId: 1
    }
  },
  components: {
    Nav,
    Footer
  },
  mounted() {
    // $('.nav-btm-line').css({
    //   left: 220 + 'px'
    // });
  }
};
</script>

<style scoped lang="less">
</style>